var render = function render(){var _vm=this,_c=_vm._self._c;return _c('address',[(_vm.url)?_c('SmartLink',{staticClass:"font-weight-bold",attrs:{"destination":_vm.url}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]):_c('span',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),(_vm.organisation)?_c('span',[_vm._v("("+_vm._s(_vm.organisation)+")")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }